import { render, staticRenderFns } from "./LayoutItems.vue?vue&type=template&id=135c4554"
import script from "./LayoutItems.vue?vue&type=script&lang=js"
export * from "./LayoutItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports